import React from 'react';

export default function Offering() {
    return (
        <section className="py-10 lg:py-20 grid place-items-center">
            offering
        </section>
    );
}
